<script>
	import {
		smartContractSideMenuOpen,
		smartContractWalletAddress,
		smartWalletName
	} from '$lib/home/scwallet/store';
	import Tooltip from '$lib/tooltip/Tooltip.svelte';

	export let title = `Add ${$smartWalletName} Balance`;

	function openMenu() {
		$smartContractSideMenuOpen = true;
	}
</script>

{#if $smartContractWalletAddress}
	<button
		on:click={openMenu}
		on:keydown={openMenu}
		class="justify-center items-center gap-3 text-fx-grey-900 font-semibold text-center rounded-xl squircle-xl bg-fx-gradient-9 py-4 cursor-pointer hidden sm:flex w-full"
	>
		{title}
		<Tooltip title="Minimum Margin required to open a trade is $50" header="Insufficient Margin">
			<div class="w-4 h-4">
				<img src="info.png" alt="" />
			</div>
		</Tooltip>
	</button>
	<div
		class="flex sm:hidden justify-center items-center gap-3 text-fx-grey-300 font-semibold text-center rounded-xl squircle-xl bg-fx-grey-600 py-3 sm:py-4 cursor-not-allowed text-xs sm:text-sm"
	>
		<span>Insufficent {$smartWalletName} Balance</span>
	</div>
{/if}
